import { ChartJsConfigHelper } from './../../../../helpers';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subscription } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { SelectedRespondentCategory, ParticipantCategoryType } from './../../../../models/reporting';
import { Component, OnInit,  Input, OnDestroy } from '@angular/core';
import * as Chart from 'chart.js';
import { EnumDescription } from '../../../../helpers';
import { ConfigService } from '../../../../services/config.service';

@Component({
  selector: 'app-respondents-by-category-module',
  templateUrl: './respondents-by-category-module.component.html',
  styles: []
})
export class RespondentsByCategoryModuleComponent implements OnInit, OnDestroy {
  @Input() respondentCategories: Array<SelectedRespondentCategory>;
  canvas: any;
  ctx: any;
  pieWidth: number;
  pieHeight: number;
  
  private colors = [];
  private getPieSubscription: Subscription = new Subscription();
  private getTranslateServiceSubscription: Subscription = new Subscription();
  constructor(private readonly translateService: TranslateService, private readonly configService: ConfigService) { }

  ngOnInit() {
    this.colors = this.configService.configData.pieColors;
    const canvasArea = document.getElementsByClassName('category-pie');
    this.pieWidth = canvasArea[0].clientWidth - 10;
    this.pieHeight =  canvasArea[0].clientHeight;
    this.getPieSubscription = this.getLabels().subscribe(x => this.buildPie(x));
    this.getTranslateServiceSubscription = this.translateService.onLangChange.pipe(
      switchMap(x => this.getLabels())
    )
    .subscribe(x => this.buildPie(x));
  }

  ngOnDestroy() {
    this.getPieSubscription.unsubscribe();
    this.getTranslateServiceSubscription.unsubscribe();
  }

  private getLabels(): Observable<Array<string>> {
    const translationKeys = this.respondentCategories
    .map(x => EnumDescription.GetDescription(ParticipantCategoryType, +x.participantCategoryType));
    return this.translateService.get(translationKeys).pipe(
      map(x => {
        const labels: Array<string> = [];
        for (const key in x) {
          if (x.hasOwnProperty(key)) {
            labels.push(x[key]);
          }
        }
        return labels;
      })
    );
  }

  private buildPie(labels: Array<string>) {
      this.canvas = document.getElementById('myPieCategories');
      this.ctx = this.canvas.getContext('2d');
      const datasets: Array<Chart.ChartDataSets> = [Object.assign({},
        {
            data: this.respondentCategories.map(r => r.value), fill: false,
            backgroundColor: this.respondentCategories.map((r, i) => this.colors[i]), borderWidth: 0
        })];
      const respondentsCategoryChart = new ChartJsConfigHelper('pieCategoryChart');
      window['pieCategoryChart'] = new Chart(this.ctx, respondentsCategoryChart.getPieChartJsOptions(labels, datasets));
  }
}

